var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTooltipOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    stroke: "#FF6542"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13574 5.60352V13H7.86426V5.60352H9.13574ZM7.76855 3.6416C7.76855 3.43652 7.83008 3.26335 7.95312 3.12207C8.08073 2.98079 8.26758 2.91016 8.51367 2.91016C8.75521 2.91016 8.93978 2.98079 9.06738 3.12207C9.19954 3.26335 9.26562 3.43652 9.26562 3.6416C9.26562 3.83757 9.19954 4.00618 9.06738 4.14746C8.93978 4.28418 8.75521 4.35254 8.51367 4.35254C8.26758 4.35254 8.08073 4.28418 7.95312 4.14746C7.83008 4.00618 7.76855 3.83757 7.76855 3.6416Z",
    fill: "#FF6542"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipOrange);
export default __webpack_public_path__ + "static/media/tooltip-orange.05c712877d8e2f854b79741ed79f2356.svg";
export { ForwardRef as ReactComponent };